<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <span class="font-weight-bold ml-1" target="_blank">{{brand}}</span>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li v-if="0" class="nav-item">
            <a href="#" class="nav-link" target="_blank">Main</a>
          </li>
          <li v-if="0" class="nav-item">
            <a href="#" class="nav-link" target="_blank">About Us</a>
          </li>
          <li v-if="0" class="nav-item">
            <a href="#" class="nav-link" target="_blank">Blog</a>
          </li>
      
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      brand: '',
    };
  },
  mounted(){
  	this.brand = this.$cs_app_long_name;
  }
};
</script>
<style></style>
